// extracted by mini-css-extract-plugin
module.exports = {"hvac-oil":"#424242","hvac-propane":"#bf360c","hvac-natural_gas":"#f4511e","hvac-electric":"#1976d2","hvac-wood":"#a1887f","hvac-pellet":"#9e9d24","hvac-other":"#424242"};